module.exports = __webpack_public_path__ + "static/media/ic_delete_orange.4a88f58c.svg";